module.exports = __webpack_public_path__ + "static/img/pay4.11c43ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pay4.png
// module id = Glqi
// module chunks = 1